import { Product } from '../../models/product/types';
import { MergedFavoriteProduct } from '../favoritProducts/FavoriteProducts.types';
import { LiveGuidelineProductRef } from '../../redux/actions/liveGuidelineActions/types';

// Live Guideline products carry their guideline id on the internal product; project products don't.
export const getLiveGuidelineScope = (
    product: Product | MergedFavoriteProduct,
): LiveGuidelineProductRef | undefined => {
    const internal = product.product;
    return internal?.liveGuidelineId
        ? { liveGuidelineId: internal.liveGuidelineId, liveGuidelineProductId: internal.id }
        : undefined;
};
